/* import __COLOCATED_TEMPLATE__ from './logo.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();